import get from 'lodash/get'

export function getShipmentWithSurveys (shipment, { sentSurveys, receivedSurveys }) {
  const rows = shipment.rows.map(row => {
    if (row.isProductRow) {
      return row
    }

    // Use direct bracket access for the batch ID key so dots in batch IDs
    // (e.g. "BAT.ADV8") are not misinterpreted as nested-path separators by lodash.
    const sentVVM = get(sentSurveys[row.batch._id], 'survey.vvm')
    const receivedVVM = get(receivedSurveys[row.batch._id], 'survey.vvm')
    return {
      ...row,
      batch: { ...row.batch, sentVVM, receivedVVM }
    }
  })
  return { ...shipment, rows }
}
